import ActionType from '../constants/actionTypes'

export function selectPart(index) {
  return {
    type: ActionType.SELECT_PART,
    payload: { index }
  }
}



// WEBPACK FOOTER //
// ./client/modules/debate/actions/strongest.js